import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getParcelKinds = () => getJson('/api/parcel-kinds');
export const getParcelKind = (name) => getJson(`/api/parcel-kinds/${name}`);
export const getIcons = () => getJson('/api/parcel-kinds/icons');
export const createParcelKind = (form) => withDone(withValidate(postJson('/api/parcel-kinds', form)))();
export const updateParcelKind = (name, form) => withDone(withValidate(putJson(`/api/parcel-kinds/${name}`, form)))();
export const deleteParcelKind = (name) => withDone(deleteJson(`/api/parcel-kinds/${name}`))();
